import { render } from "./ProductAdjustmentTable.vue?vue&type=template&id=0abedca8&scoped=true"
import script from "./ProductAdjustmentTable.vue?vue&type=script&lang=js"
export * from "./ProductAdjustmentTable.vue?vue&type=script&lang=js"

import "./ProductAdjustmentTable.vue?vue&type=style&index=0&id=0abedca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abedca8"]])

export default __exports__